import { useEffect, useState } from "react";
import axios from "axios";
import "./Products.css";

import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import Footer from "../components/Footer";

export default function AddProduct() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [dark, setDark] = useState(false);
  const [loading, setLoading] = useState(false);

  const [products, setProducts] = useState([]);

  const [form, setForm] = useState({
    title: "",
    category: "",
    subCategory: "",
    price: "",
    stock: "",
    warranty: "",
    description: "",
    image: ""
  });

  /* THEME */
  useEffect(() => {
    if (localStorage.getItem("theme") === "dark") setDark(true);
  }, []);

  useEffect(() => {
    document.body.classList.toggle("dark", dark);
    localStorage.setItem("theme", dark ? "dark" : "light");
  }, [dark]);

  /* FETCH PRODUCTS */
  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    const res = await axios.get("http://localhost:5000/api/products");
    setProducts(res.data);
  };

  /* SAVE PRODUCT (JSON) */
  const saveProduct = async () => {
    if (
      !form.title ||
      !form.category ||
      !form.subCategory ||
      !form.price ||
      !form.image
    ) {
      alert("Please fill all required fields");
      return;
    }

    try {
      setLoading(true);

      await axios.post("http://localhost:5000/api/products", {
        title: form.title,
        category: form.category,
        subCategory: form.subCategory,
        price: Number(form.price),
        stock: Number(form.stock || 0),
        warranty: form.warranty,
        description: form.description,
        image: form.image
      });

      alert("✅ Product added successfully");

      setForm({
        title: "",
        category: "",
        subCategory: "",
        price: "",
        stock: "",
        warranty: "",
        description: "",
        image: ""
      });

      fetchProducts();
    } catch (err) {
      console.error(err);
      alert("❌ Failed to add product");
    } finally {
      setLoading(false);
    }
  };

  const formatDateTime = (date) =>
    new Date(date).toLocaleString("en-IN", {
      dateStyle: "medium",
      timeStyle: "short"
    });

  return (
    <div className="admin-body">
      <Sidebar open={sidebarOpen} />

      <Topbar
        onMenu={() => setSidebarOpen(!sidebarOpen)}
        onTheme={() => setDark(!dark)}
      />

      <main className="admin-main">
        <h1>Add Product</h1>

        {/* FORM */}
        <section className="table-card">
          <div className="form-grid">
            <div className="left">
              <label>Product Title *</label>
              <input
                value={form.title}
                onChange={(e) =>
                  setForm({ ...form, title: e.target.value })
                }
              />

              <label>Category *</label>
              <select
                value={form.category}
                onChange={(e) =>
                  setForm({ ...form, category: e.target.value })
                }
              >
                <option value="">Select</option>
                <option>10/25G Data Center Switches</option>
              </select>

              <label>Sub Category *</label>
              <select
                value={form.subCategory}
                onChange={(e) =>
                  setForm({ ...form, subCategory: e.target.value })
                }
              >
                <option value="">Select</option>
                <option>10/25G</option>
                <option>100G</option>
                <option>400G</option>
                <option>Modular</option>
                <option>NVIDIA</option>
                <option>Accessories</option>
              </select>

              <label>Description / Highlights</label>
              <textarea
                value={form.description}
                onChange={(e) =>
                  setForm({ ...form, description: e.target.value })
                }
              />
            </div>

            <div className="right">
              <label>Price *</label>
              <input
                type="number"
                value={form.price}
                onChange={(e) =>
                  setForm({ ...form, price: e.target.value })
                }
              />

              <label>Stock</label>
              <input
                type="number"
                value={form.stock}
                onChange={(e) =>
                  setForm({ ...form, stock: e.target.value })
                }
              />

              <label>Warranty</label>
              <input
                value={form.warranty}
                onChange={(e) =>
                  setForm({ ...form, warranty: e.target.value })
                }
              />

              <label>Image URL *</label>
              <input
                placeholder="https://example.com/image.jpg"
                value={form.image}
                onChange={(e) =>
                  setForm({ ...form, image: e.target.value })
                }
              />

              {form.image && (
                <img
                  src={form.image}
                  alt="preview"
                  style={{ width: 120, marginTop: 10 }}
                />
              )}
            </div>
          </div>

          <div className="actions">
            <button
              className="primary"
              onClick={saveProduct}
              disabled={loading}
            >
              {loading ? "Saving..." : "💾 Save Product"}
            </button>
          </div>
        </section>

        {/* TABLE */}
        <section className="table-card" style={{ marginTop: 30 }}>
          <h2>All Products</h2>

          <table className="data-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Image</th>
                <th>Title</th>
                <th>Category</th>
                <th>Sub</th>
                <th>Price</th>
                <th>Created</th>
              </tr>
            </thead>
            <tbody>
              {products.map((p, i) => (
                <tr key={p._id}>
                  <td>{i + 1}</td>
                  <td>
                    {p.image && (
                      <img src={p.image} width="50" />
                    )}
                  </td>
                  <td>{p.title}</td>
                  <td>{p.category}</td>
                  <td>{p.subCategory}</td>
                  <td>₹{p.price}</td>
                  <td>{formatDateTime(p.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      </main>

      <Footer />
    </div>
  );
}
